import React, { useState, useEffect, useMemo, useRef } from "react";
import StarIcon from "@mui/icons-material/Star";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";
import { search_icon } from "../../assets/imgs";
import { Table } from "../../components/Table/Table";
import { admin_list } from "../redux/api/dummyJson";
import CancelIcon from "@mui/icons-material/Cancel";
import DatePicker from "react-datepicker";
import {
  useSuspendedDescriptionAddMutation,
  useSuspendedViewTableListMutation,
} from "../redux/api/api";
import JoditEditor from "jodit-react";
import { configJodit } from "../../screens/redux/api/Constants";
import { toast } from "react-toastify";

const MMCReqView = () => {
  const navigate = useNavigate();
  const [popup, setPopup] = useState(false);
  const [pageno, setPageno] = useState(1);
  const [pagecount, setPagecount] = useState("");
  const [descPopup, setDescPopup] = useState(false);
  const [name, setName] = useState("");
  const [ownerName, setOwnerName] = useState("");
  const [BookingId, setBookingId] = useState("");
  const [propertyId, setPropertyId] = useState("");
  const [city, setCity] = useState("");
  const [rating, setRating] = useState("");
  const [comment, setComment] = useState("");
  const [count, setCount] = useState();
  const [list, setList] = useState([]);
  const [description, setDescription] = useState("");
  const [fromdate, setFromDate] = useState(
    moment(new Date()).format("YYYY-MM-DD")
  );
  const [toDate, setToDate] = useState(moment(new Date()).format("YYYY-MM-DD"));
  const [search, setSearch] = useState("");

  const [type, setType] = useState();

  const textareaRef = useRef(null);
  const handleChange = (e) => {
    setDescription(e.target.value);

    // Reset height to auto before calculating scrollHeight
    textareaRef.current.style.height = "auto";
    textareaRef.current.style.height = textareaRef.current.scrollHeight + "px";
  };

  const [loading, setLoading] = useState(false);

  const [addDescription, setAddDescription] = useState("");

  const location = useLocation();

  const data = location?.state?.data;

  console.log("data", data?.property?.suspend_comment_id);

  const editor = useRef(null);

  const joditConfig = useMemo(
    () => ({
      ...configJodit,
    }),
    []
  );

  const [comment_id, setComment_id] = useState("");

  console.log("comment_id", comment_id);

  const [suspendedViewTableList] = useSuspendedViewTableListMutation();
  const [suspendedDescriptionAdd] = useSuspendedDescriptionAddMutation();

  const getList = (
    page,
    search,
    fromdate,
    toDate,
    selectedPropertyId,
    comment_id
  ) => {
    const formdata = new FormData();

    if (fromdate && toDate) {
      formdata.append("from_date", moment(fromdate).format("YYYY-MM-DD"));
      formdata.append("to_date", moment(toDate).format("YYYY-MM-DD"));
    }

    if (selectedPropertyId) {
      formdata.append("property_id", selectedPropertyId);
    }

    formdata.append("page", page);
    formdata.append("row", 10);

    formdata.append(
      "chat_id",
      data?.property?.suspend_comment_id
        ? data?.property?.suspend_comment_id
        : comment_id
        ? comment_id
        : ""
    );

    if (search) {
      formdata.append("search", search);
    }

    console.log("formdata", formdata);

    suspendedViewTableList(formdata)
      .unwrap()
      .then((res) => {
        console.log("res", res);
        let temp = [];
        res?.followups?.map((item, ind) => {
          let obj = { ...item };
          obj.current_page = res?.pagination?.current_page;
          obj.admin_name = item?.admin?.username;
          temp.push(obj);
        });
        setList(temp);
        setPagecount(res?.pagination);
        setCount(res?.pagination?.total);
        setType(res?.suspent_type);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const handleSubmit = () => {
    setLoading(true);
    let payload = {
      property_id: data?.property_id,
      type: type,
      description: addDescription,
      chat_id: comment_id ? comment_id : null,
    };
    suspendedDescriptionAdd(payload)
      .then((res) => {
        console.log("desc_res", res);
        if (res?.data?.status == "success") {
          console.log("res?.data?.data?.chat_id", res?.data?.data?.chat_id);
          toast.success(res?.data?.message);
          setPopup(false);
          setLoading(false);
          setAddDescription("");
          setComment_id(res?.data?.data?.chat_id);
          getList(
            pageno,
            search,
            fromdate,
            toDate,
            data?.property_id,
            res?.data?.data?.chat_id
          );
        }
      })
      .catch((err) => {
        console.log("desc_err", err);
        setLoading(false);
        toast.error(err?.data?.message);
      });
  };

  useEffect(() => {
    getList(pageno, search, fromdate, toDate, data?.property_id);
    if (data?.property?.suspend_comment_id) {
      setComment_id(data?.property?.suspend_comment_id);
    }
  }, [pageno]);

  useEffect(() => {
    // Resize initially (in case there's pre-filled content)
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto";
      textareaRef.current.style.height =
        textareaRef.current.scrollHeight + "px";
    }
  }, [description]);

  const columns = React.useMemo(
    () => [
      {
        Header: "Ticket ID",
        accessor: "followup_uid",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: "Admin Name",
        accessor: "admin",
        Cell: ({ value, row }) => {
          return <p>{value?.username ? value?.username : value?.name}</p>;
        },
      },
      {
        Header: "Description",
        accessor: "description",
        Cell: ({ value }) => {
          const plainText = value.replace(/<[^>]+>/g, "");
          return (
            <p
              className="pointer"
              onClick={() => {
                setDescPopup(true);
                setDescription(plainText);
              }}
            >
              {plainText.substring(0, 50)}
            </p>
          );
        },
      },
      {
        Header: "Date & Time",
        accessor: "created_at",
        Cell: ({ value, row }) => {
          return <p>{moment(value).format("DD-MM-YYYY, h:mm a")}</p>;
        },
      },
    ],
    []
  );
  return (
    <div className="dashRightView home_section">
      <div className="d-flex ac-jb">
        <h2 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 sec">
          MMC Cancellation - Request View
        </h2>
      </div>
      <div className="" style={{ borderBottom: "1px solid #000" }}>
        <div className="d-flex gap-5 mb-4">
          <div className="col-md-5">
            <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
              Property ID
            </h4>
            <input
              type="number"
              readOnly
              value={data?.property_id}
              onChange={(e) => setPropertyId(e.target.value)}
              className="input-pop ps-2 w-100"
              placeholder="Property ID"
            />
          </div>
          <div className="col-md-5">
            <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
              Property Name
            </h4>
            <input
              type="text"
              readOnly
              value={data?.property?.name}
              onChange={(e) => setName(e.target.value)}
              className="input-pop ps-2 w-100"
              placeholder="Property Name"
            />
          </div>
        </div>
        <div className="d-flex gap-5 mb-4">
          <div className="col-md-5">
            <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
              Owner Name
            </h4>
            <input
              type="text"
              readOnly
              value={data?.owner?.name}
              onChange={(e) => setOwnerName(e.target.value)}
              className="input-pop ps-2 w-100"
              placeholder=" Owner Name"
            />
          </div>
          <div className="col-md-5">
            <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
              Requested Date
            </h4>
            <input
              type="text"
              readOnly
              value={moment(data?.created_at).format("DD-MM-YYYY")}
              onChange={(e) => setBookingId(e.target.value)}
              className="input-pop ps-2 w-100"
              placeholder="Requested Date"
            />
          </div>
        </div>
        <div className="d-flex gap-5 mb-4">
          <div className="col-md-5">
            <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
              Type
            </h4>
            <input
              type="text"
              readOnly
              value={
                data?.property?.property_type == 2 ? "Individual" : "Rooms"
              }
              onChange={(e) => setType(e.target.value)}
              className="input-pop ps-2 w-100"
              placeholder="Type"
            />
          </div>
          <div className="col-md-5">
            <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
              City
            </h4>
            <input
              type="text"
              readOnly
              value={data?.property?.city?.name}
              onChange={(e) => setCity(e.target.value)}
              className="input-pop ps-2 w-100"
              placeholder="City"
            />
          </div>
        </div>
      </div>
      <div className="d-flex ac-je mt-4 gap-2">
        <label className="f2 fs-sm-10 fs-md-10 fs-lg-12 fs-xl-14 fs-xxl-16 primary">
          From Date
        </label>
        <div className="w-15">
          <DatePicker
            type="date"
            dateFormat="dd-MM-yyyy"
            className="input-pop-new ps-2 w-100"
            placeholderText="From Date"
            selected={fromdate}
            onChange={(date) => {
              setFromDate(date);
              getList(1, search, date, toDate, data?.property_id);
            }}
          />
        </div>
        <label className="f2 fs-sm-10 fs-md-10 fs-lg-12 fs-xl-14 fs-xxl-16 primary">
          To Date
        </label>
        <div className="w-15">
          <DatePicker
            type="date"
            dateFormat="dd-MM-yyyy"
            className="input-pop-new ps-2 w-100"
            placeholderText="To Date"
            selected={toDate}
            onChange={(date) => {
              setToDate(date);
              getList(1, search, fromdate, date, data?.property_id);
            }}
          />
        </div>
        <div
          // onChange={(e) => suspendedList(fromdate, toDate, selectedPropertyId, e.target.value, 1)}
          className="search-input"
        >
          <input
            type="text"
            placeholder="Search"
            style={{ border: "none", width: "100px" }}
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
              getList(1, e.target.value, fromdate, toDate, data?.property_id);
            }}
          />
          <img src={search_icon} className="search" />
        </div>
        <button
          onClick={() => setPopup(true)}
          className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 white add-btn "
        >
          {" "}
          + Add
        </button>
      </div>
      {descPopup && (
        <div className="img-popup-design">
          <div className="img-popup">
            <div className="d-flex ac-je">
              <button
                className="cust-btn"
                onClick={() => {
                  setDescPopup(false);
                }}
              >
                <CancelIcon />
              </button>
            </div>
            <textarea
              ref={textareaRef}
              className="input-pop ps-2 w-100 mt-3"
              placeholder="Description"
              value={description}
              onChange={handleChange}
              style={{
                overflowY: "auto",
                resize: "none",
                maxHeight: "80vh",
                minHeight: "100px",
              }}
            />
          </div>
        </div>
      )}
      {popup && (
        <div className="img-popup-design">
          <div className="img-popup">
            <div className="d-flex ac-je">
              <button
                className="cust-btn"
                onClick={() => {
                  setPopup(false);
                  setName("");
                }}
              >
                <CancelIcon />
              </button>
            </div>
            <h4 className="f1 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
              Description
            </h4>
            <textarea
              value={addDescription}
              onChange={(e) => setAddDescription(e.target.value)}
              className="input-pop ps-2 w-100"
              placeholder="Description"
              style={{ height: "150px" }}
            />

            {/* <JoditEditor
                            ref={editor}
                            config={joditConfig}
                            value={addDescription}
                            onChange={(newContent) => setAddDescription(newContent)}
                        /> */}

            <div style={{ textAlign: "center", marginTop: "30px" }}>
              <button
                onClick={() => handleSubmit()}
                className="login-btn f2 fs-sm-10 fs-md-8 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3"
              >
                {/* {loading && (
                                    <div
                                        class="spinner-border spinner-border-sm"
                                        style={{ marginRight: "5px" }}
                                    ></div>
                                )}  Submit */}
                {loading ? "Loading..." : "Submit"}
              </button>
            </div>
          </div>
        </div>
      )}
      <Table
        columns={columns}
        data={list}
        setPageno={setPageno}
        pagecount={pagecount}
        show={true}
      />
    </div>
  );
};

export default MMCReqView;
